import {select} from '@wordpress/data';
import {getSetting} from '@woocommerce/settings';
import {checkoutEventsEmitter} from '@woocommerce/blocks-checkout-events';
import {PAYMENT_STORE_KEY} from '@woocommerce/block-data';
import grecaptcha from '@ppcp/recaptcha-external';

const settings = getSetting('ppcpReCaptcha_data');

const createToken = async () => {
    const {paymentMethods, siteKey} = settings;
    const activePaymentMethod = select(PAYMENT_STORE_KEY).getActivePaymentMethod();

    if (!paymentMethods.some(method => activePaymentMethod?.startsWith(method))) {
        return null;
    }

    try {
        await new Promise(resolve => grecaptcha.ready(resolve));
        const token = await grecaptcha.execute(siteKey, {action: 'submit'});
        return {type: 'success', data: {ppcp_recaptcha_response: token}};
    } catch (e) {
        return null;
    }
};

checkoutEventsEmitter.subscribe(() => createToken(), 10, 'ppcp_order_create');
checkoutEventsEmitter.subscribe(() => createToken(), 10, 'ppcp_vault_token_create');
checkoutEventsEmitter.subscribe(() => createToken(), 10, 'ppcp_billing_agreement_create');